import { RootState } from '../../../store/types';

export const submitSignatureIsLoadingSelector = (state: RootState) => state.myQuoteReducer.submitSignatureIsLoading;
export const submitSignatureIsSuccessSelector = (state: RootState) => state.myQuoteReducer.submitSignatureIsSuccess;
export const submitSignatureHasErrorSelector = (state: RootState) => state.myQuoteReducer.submitSignatureHasError;
export const getQuoteDataSelector = (state: RootState) => state.myQuoteReducer.getQuoteData;
